import Router from 'vue-router';
import login from './login';
import amortizations from './amortizations';
import brands from './brands';
import categories from './categories';
import checkBook from './check-book';
import commissions from './commissions';
import companies from './companies';
import customers from './customers';
import dashboard from './dashboard';
import dispatch from './dispatch';
import features from './features';
import guides from './guides';
import inventories from './inventories';
import newExpense from './new-expenses';
import listOfPrices from './list-of-prices';
import listOfTransfers from './list-of-transfers';
import newClient from './new-client';
import newQuotation from './new-quotation';
import newSale from './new-sale';
import products from './products';
import productEdit from './edit-product';
import productNew from './new-product';
import project from './project';
import quotations from './quotations';
import referenceGuides from './reference-guides';
import sales from './sales';
import settings from './settings';
import terminals from './terminals';
import typeExpenses from './type-expenses';
import units from './units';
import users from './users';
import warehousesTransfer from './warehouses-transfer';
import warehouses from './warehouses';
import work from './work';
import subsidiaries from './subsidiaries';
import editQuotation from './edit-quotation';
import expenses from './expenses';
import reports from './reports';
import bankAccounts from './bank-account';
import newBankAccount from './new-accounts-bank';
import editBankAccount from './edit-accounts-bank';
import accounting from './accounting';
import cashClosing from './cash-closing';
import countableAuxiliary from './countable-auxiliary';
import quipuCustomers from './quipu-customers';
import testPage from './test-page';
import cashDeskClosing from './cash-desk-closing';
import purchases from './purchases';
import purchasesNew from './purchases-new';
import purchasesDetails from './purchases-details';
import groups from './groups';
import suppliers from './suppliers';
import debtsToPay from './debts-to-pay';
import debtsToPayHistory from './debts-to-pay-history';
import purchasesEdit from './purchases-edit';
import purchasesClone from './purchases-clone';
import movements from './movements';
import bankReconciliations from './bank-reconciliations';
import bankReconciliationsHistory from './bank-reconciliations-history';
import documents from './documents';
import transfersDetails from './transfers-details';
import withholding from './withholding';
import customersNew from './customers-new';
import couriers from './couriers';
import customersEdit from './customers-edit';
import payroll from './payroll';
import ecommerce from './ecommerce';
import costCenter from './cost-center';
import controlSeries from './control-series';
import dailySummary from './daily-summary';
import dailySummaryCreate from './daily-summary-create';
import newTransferDetail from './new-transfers-detail';
import transfersStart from './transfers-start';
import rating from './rating';
import questionsAndAnswers from './questions-and-answers';
import listOfReturns from './list-of-returns';
import detailReturns from './returns-details';
import trackingTransfer from './transfers-tracking';
import fieldSale from './field-sale';
import components from './components';
import accountsReceivable from './accounts-receivable';
import accountsToPay from './accounts-to-pay';
import zones from './zones';
import newCompositeProduct from './new-composite-product';
import dashboardWarehouses from './dashboard-warehouses';
import dashboardSalePoints from './dashboard-sale-points';
import dailySummaryDetail from './daily-summary-detail';
import device from './device';
import sri from './sri';
import routes from './routes';
import newRoute from './new-route';
import cancelSummary from './cancel-summary';
import vendors from './vendors';
import newVendor from './new-vendor';
import cash from './cash';
import cancelSummaryDetail from './cancel-summary-detail';

export default function (Vue) {
	Vue.use(Router);
	const config = new Router({
		mode: 'history',
		routes: [
			{
				path: '/',
				name: 'admin-container',
				redirect: '/products',
				children: [
					accounting,
					amortizations,
					bankAccounts,
					brands,
					cashDeskClosing,
					categories,
					checkBook,
					commissions,
					companies,
					components,
					customers,
					dashboard,
					dashboardWarehouses,
					dispatch,
					documents,
					editBankAccount,
					editQuotation,
					expenses,
					features,
					guides,
					inventories,
					newExpense,
					listOfPrices,
					listOfTransfers,
					newBankAccount,
					newClient,
					newQuotation,
					newTransferDetail,
					newSale,
					products,
					productEdit,
					productNew,
					project,
					quotations,
					referenceGuides,
					reports,
					sales,
					settings,
					subsidiaries,
					terminals,
					typeExpenses,
					units,
					users,
					warehousesTransfer,
					warehouses,
					withholding,
					work,
					cashClosing,
					countableAuxiliary,
					quipuCustomers,
					testPage,
					purchases,
					purchasesNew,
					purchasesClone,
					purchasesDetails,
					transfersStart,
					groups,
					suppliers,
					debtsToPay,
					debtsToPayHistory,
					purchasesEdit,
					movements,
					bankReconciliations,
					bankReconciliationsHistory,
					transfersDetails,
					customersNew,
					couriers,
					customersEdit,
					payroll,
					ecommerce,
					costCenter,
					controlSeries,
					dailySummary,
					dailySummaryCreate,
					rating,
					questionsAndAnswers,
					listOfReturns,
					detailReturns,
					trackingTransfer,
					fieldSale,
					accountsReceivable,
					accountsToPay,
					zones,
					newCompositeProduct,
					dashboardSalePoints,
					dailySummaryDetail,
					device,
					sri,
					routes,
					newRoute,
					cancelSummary,
					vendors,
					newVendor,
					cash,
					cancelSummaryDetail,
				],
				components: {
					default: () => import('@/components/admin-container'),
				},
			},
			login,
		],
	});
	config.beforeEach((to, from, next) => {
		if (to.name !== 'list-of-transfers' && to.name !== 'pages-transfers-detail' && to.name !== 'pages-transfers-tracking') {
			localStorage.removeItem(`${process.env.STORAGE_USER_KEY}::filter-transfers`);
		}
		if (to.meta) {
			const sidebar = JSON.parse(window.localStorage.getItem(`${process.env.STORAGE_USER_KEY}::sidebar`));
			if (sidebar) {
				let currentRoute;
				sidebar.forEach((item) => {
					if (!currentRoute) {
						currentRoute = item.resource.data.find(r => r.uri === to.name);
					}
				});
				const title = currentRoute ? currentRoute.title : to.meta.title;
				window.document.title = title;
				/* eslint-disable no-param-reassign */
				to.meta.title = title;
			}
		}
		if (to.name !== 'login') {
			const token = window.localStorage.getItem(`${process.env.STORAGE_USER_KEY}::token`);
			if (token) {
				return next();
			}
			return next({ name: 'login' });
		}
		return next();
	});
	return config;
}



// WEBPACK FOOTER //
// ./src/router/index.js